import _ from 'lodash';
import { makeAutoObservable, runInAction } from 'mobx';
import { ButtonComponentType } from '../../component/button/button.component';
import GlobalNotification from '../../component/common/snackbar';
import { Data, HeadCell } from '../../component/table/table.component';
import i18n from '../../i18n';
import { Condition } from '../../models/abstract/condition.entity';
import { Group } from '../../models/group.entity';
import { Restaurant } from '../../models/restaurant.entity';
import { Staff } from '../../models/staff.entity';
import apiManage from '../../request';
import { editAccountMobx } from '../group/account-manage/edit-account';
import { groupUnitData } from '../group/group-unit';
import { Reseller } from '../../models';

// 资源回收站数据管理
export class DeletedResourceState implements DeletedResourceData {

    constructor() {
        makeAutoObservable(this);
    }

    // *********************
    // Provider
    // *********************

    // 下拉框默认值
    selectValue: SelectType = 'group';
    // 表格加载
    isTableLoading: boolean = false;
    // 表格数据总数
    dataTotal: number = 0;
    // 表格数据集合
    tableLists: {
        group: Group[];
        restaurant: Restaurant[];
        account: Staff[];
        reseller: Reseller[]

    } = {
            // 集团
            group: [],
            // 餐厅
            restaurant: [],
            // 账号
            account: [],
            // 经销商
            reseller: []
        };
    // 表格请求额外传参  用于表格排序
    extraParams: {
        group?: Condition,
        restaurant?: Condition,
    } = {
            group: {},
            restaurant: {}
        };
    // 列表排序
    listSortParams: {
        sort_key: string;
        sort_value: string;
        sort_control: number;
    } = {
            sort_key: '',
            sort_value: '',
            sort_control: 0
        }
    // 删除弹框配置
    confirmDialogConfig: {
        type?: 'DELETE' | 'RESTORE',
        desc?: string;
        visible: boolean;
        forbidConfirm?: number;
        handleClick?: (value: boolean) => Promise<void>;
    } = {
            visible: false,
            forbidConfirm: 0
        };
    // 弹窗组件配置
    dialogConfig: {
        // 打开
        visible: boolean;
        // 选择的id
        selectId?: string;
        // 所属集团
        belonged_group?: string;
        // 关闭
        onClose?: () => void;
    } = {
            visible: false,
            selectId: '',
            onClose: () => { },
        };
    // 账号详情弹窗配置
    accountDialogConfig: {
        visible: boolean;
        onClose?: () => void;
    } = {
            visible: false,
            onClose: () => { }
        };

    // 骨架屏控制
    isEnableSkeleton: boolean = false;
    // 账户删除资源视图数据
    accountViewData: Staff | null = null;
    // 账号详情骨架屏控制
    skeleton: boolean = false;
    // 排序map
    sortInfoMap: Record<number | 'default', { value: string, sortControl: number }> = {
        0: { value: '-1', sortControl: 1 },
        1: { value: '1', sortControl: 2 },
        2: { value: '', sortControl: 0 },
        default: { value: '', sortControl: 0 }
    };
    // 要排序的对应的表格map
    sortParamsMap: Record<SelectType | 'default', sortKeyType> = {
        // 集团
        group: {
            nickname: 'nickname',
            deleted_date: 'deleted_date',
        },
        // 餐厅
        restaurant: {
            city: 'city',
            nickname: 'nickname',
            deleted_date: 'deleted_date'
        },
        account: {
            deleted_date: 'deleted_date',
        },
        reseller: {
            deleted_date: 'deleted_date',
        },
        default: {}
    };
    /**
     * 列表按钮组
     * @param row @typedef Group 集团类型 | @typedef Restaurant 餐厅类型 | @typedef Staff 账号类型
     */
    buttonsMap: Record<SelectType, (row: any) => ButtonComponentType[]> = {
        // 集团按钮组
        'group': (row) => [
            {
                variant: 'contained',
                color: 'secondary',
                action: 'DELETE',
                handleClick: () => this.updateDeleteDialogConfig(row)
            },
            {
                variant: 'contained',
                action: 'RESTORE',
                handleClick: () => this.handleRestoreDialog([row])
            },
            {
                variant: 'contained',
                action: 'VIEW',
                handleClick: () => {
                    // 打开详情弹窗
                    this.upDateDeleteDialog({
                        visible: true,
                        selectId: row?._id || '',
                        belonged_group: row?.string_id || '',
                        onClose: () => {
                            this.upDateDeleteDialog({
                                visible: false,
                                selectId: '',
                                belonged_group: '',
                            })
                        }
                    })
                }
            }
        ],
        // 餐厅按钮组
        'restaurant': (row) => [
            {
                variant: 'contained',
                color: 'secondary',
                action: 'DELETE',
                handleClick: () => this.updateDeleteDialogConfig(row)
            },
            {
                variant: 'contained',
                action: 'RESTORE',
                handleClick: () => this.handleRestoreDialog([row])
            },
            {
                variant: 'contained',
                action: 'VIEW',
                handleClick: () => {
                    // 打开详情弹窗
                    this.upDateDeleteDialog({
                        visible: true,
                        selectId: row?._id ?? '',
                        belonged_group: row?.belonged_group ?? '',
                        onClose: () => {
                            this.upDateDeleteDialog({
                                visible: false,
                                selectId: '',
                                belonged_group: '',
                            })
                        }
                    });
                }
            }
        ],
        // 账号按钮组
        'account': (row) => [
            {
                variant: 'contained',
                color: 'secondary',
                action: 'DELETE',
                handleClick: () => this.updateDeleteDialogConfig(row)
            },
            {
                variant: 'contained',
                action: 'RESTORE',
                handleClick: () => this.handleRestoreDialog([row])
            },
            {
                variant: 'contained',
                action: 'VIEW',
                handleClick: async () => {
                    // 打开详情弹窗
                    this.upDateAccountDialog({
                        visible: true,
                        onClose: () => {
                            this.upDateAccountDialog({
                                visible: false
                            })
                        }
                    })
                    // 请求数据
                    if (row?._id) {
                        // 设置界面输入框禁用
                        editAccountMobx.updateDisable(true);
                        // 设置集团id  方便查找对应数据
                        groupUnitData.updateGroupId(row?.belonged_group[0] || {});
                        // 关闭骨架屏
                        this.setSkeleton(true);
                        await editAccountMobx.getAccountInfo(row?._id);
                        // 关闭骨架屏
                        this.setSkeleton(false);
                    }
                }
            }
        ],
        // 经销商按钮组
        'reseller': (row) => [
            {
                variant: 'contained',
                color: 'secondary',
                action: 'DELETE',
                handleClick: () => this.updateDeleteDialogConfig(row)
            },
            {
                variant: 'contained',
                action: 'RESTORE',
                handleClick: () => this.handleRestoreDialog([row])
            },
            {
                variant: 'contained',
                action: 'VIEW',
                handleClick: () => {
                    // 打开详情弹窗
                    this.upDateDeleteDialog({
                        visible: true,
                        selectId: row?._id ?? '',
                        onClose: () => {
                            this.upDateDeleteDialog({
                                visible: false,
                                selectId: '',
                            })
                        }
                    });
                }
            }
        ]
    };

    // *********************
    // Business Function
    // *********************

    // 初始化
    async init() {
        await this.getGroupDeletedList();
    }

    /**
     * 获取表头排序值
     * @param key
     * @returns
     */
    getSortStatus(key: string) {
        const listSort = this.listSortParams;
        if (key === listSort.sort_key) {
            return listSort.sort_control
        }
        return 0;
    }

    /**
     * 更新弹窗状态 集团 | 餐厅
     * @param configData
     */
    upDateDeleteDialog(configData: typeof this.dialogConfig) {
        this.dialogConfig = configData;
    }



    /**
     * 更新删除弹窗数据
     * @param deleteConfigData
     */
    updateConfirmDialogConfig(deleteConfigData: typeof this.confirmDialogConfig) {
        this.confirmDialogConfig = {
            ...this.confirmDialogConfig,
            ...deleteConfigData,
        }
    }

    /**
     * 更新删除弹窗数据
     * @param row 
     */
    updateDeleteDialogConfig(row) {
        this.updateConfirmDialogConfig({
            type: 'DELETE',
            visible: true,
            desc: '',
            handleClick: async () => {
                if (row._id) {
                    // 请求删除
                    await this._handleDelete(row, false);
                }
            }
        });
    }

    /**
     * 更新账户弹窗状态
     * @param configData
     */
    upDateAccountDialog(configData: typeof this.accountDialogConfig) {
        this.accountDialogConfig = configData;
    }

    // 设置骨架屏  用于账号弹窗
    setSkeleton(skeleton: boolean) {
        this.skeleton = skeleton;
    }

    /**
     * 设置排序字段 排序优化重写
     * 1.排序
     * 2.保存参数
     * 3.改变头部状态
     * @param headCell 排序的字段
     */
    async _handleSort(headCell: HeadCell) {
        let value = '1';
        let sortControl = 0;
        // 排序对象
        const sortInfo = this.sortInfoMap[headCell.sortStatus || 0] || this.sortInfoMap['default'];
        // 排序值
        value = sortInfo?.value || '';
        // 排序键值控制
        sortControl = sortInfo?.sortControl || 0;
        // 设置排序参数
        this.setExtraSortParams({
            sort_key: sortControl === 0 ? '' : headCell.id,
            sort_value: value,
            sort_control: sortControl
        });
        // 排序传参obj
        let sortObj = {} as { sort_key: string; sort_value: string };
        // 排序取的参数
        const sortParams = this.sortParamsMap[this.selectValue];
        // 如果是0表示不排序
        if (sortControl && this.listSortParams?.sort_value) {
            // 查找要排序的sort_key
            const sortKey = sortParams[this.listSortParams?.sort_key as keyof sortKeyType] || '';
            sortObj = {
                sort_key: sortKey,
                sort_value: this.listSortParams.sort_value,
            };
        }
        // 刷新数据
        await this.refreshData(sortObj);
    }

    // 设置排序参数
    setExtraSortParams(sortVal: {
        sort_key: string,
        sort_value: string,
        sort_control: number
    }) {
        this.listSortParams = sortVal;
    }

    /**
     * 排序刷新数据用
     * @param extraParams 额外传参  用于表格排序
     */
    async refreshData(extraParams?: any) {
        const value = this.selectValue;
        switch (value) {
            case 'group':
                await this.getGroupDeletedList(extraParams);
                break;
            case 'restaurant':
                await this.getRestaurantDeletedList(extraParams);
                break;
            case 'account':
                await this.getAccountDeletedList(extraParams);
                break;
            case 'reseller':
                await this.getResellerDeletedList(extraParams);
                break;
            default: return {};
        }
    }

    /**
     * 删除列表数据函数  多选 或者 单个
     * @param deleteRowData 选择的行数据  删除数据类型定为any是因为有 集团 | 餐厅 | 账号 的数据类型
     * @param isBatch 批量删除标识
     * @typedef Group 集团 | @typedef Restaurant 餐厅 | @typedef Staff 账号 |
     */
    async _handleDelete(deleteRowData: any, isBatch?: boolean) {
        try {
            const { _id } = deleteRowData || {};
            // 删除的数据
            const deleteData = isBatch ?
                (deleteRowData as any[]).map(item => item?._id || '') || []
                : (_id || '');

            // 删除要请求的api
            const deleteApiMap = {
                'group': isBatch ? apiManage.delete_group_hard : apiManage.delete_group_hard_id,
                'restaurant': isBatch ? apiManage.delete_restaurant_hard : apiManage.delete_restaurant_id_hard,
                'account': isBatch ? apiManage.delete_staff_hard : apiManage.delete_staff_id_hard,
                'reseller': isBatch ? apiManage.delete_reseller_hard : apiManage.delete_reseller_id_id_hard,
            };

            // 返回结果 发起删除请求
            const result = await deleteApiMap[this.selectValue](deleteData);

            if (!('error' in result)) {
                const message = isBatch ? i18n.t('general_message_text_batch_delete_successfully')
                    : i18n.t('general_message_text_delete_successfully');
                GlobalNotification.success(message);

                // 刷新数据
                await this.refreshData();
            } else {
                const { code = '', message = '', details = '' } = result?.result || {};

                // 未满14天不可删除
                if (code === 1008) {
                    GlobalNotification.error(i18n.t('deleted_resource_page_text_less_than_fourteen_days_cannot_deleted'));
                } else {
                    GlobalNotification.error(message || details);
                }
            }
            this.updateConfirmDialogConfig({ visible: false });
        } catch (error) {
            GlobalNotification.error(i18n.t('general_text_network_error'));
        }
    }

    // 开启骨架屏
    enableSkeleton() {
        this.isEnableSkeleton = true;
    }

    // 关闭骨架屏
    closeSkeleton() {
        this.isEnableSkeleton = false;
    }

    // 开启表格加载
    loadTable() {
        this.isTableLoading = true;
    }

    // 关闭表格加载
    loadedTable() {
        this.isTableLoading = false;
    }

    // 获取集团删除资源数据
    async getGroupDeletedList(extraParams?: Condition) {
        try {
            /**
             * 1.开启table loading
             * 2.无论成功与否关闭loading
             */
            this.loadTable();
            const params = {
                is_deleted: true,
                pagination_per_page: 999,
                pagination_page: 1,
                sort_key: 'deleted_date',
                sort_value: -1,
                ...extraParams
            }
            const result = await apiManage.get_group_by_condition(params);
            // 请求成功
            if (!result.error) {
                // 解构数据
                const { dbResults } = result[0];
                runInAction(() => {
                    this.tableLists.group = dbResults || [];
                })
            } else {
                // 请求失败
                GlobalNotification.error(`${i18n.t('group_management_page_text_failed_get_group_list')}`);
            }
            this.loadedTable();
        } catch (e) {
            console.log(e);
            // 请求失败
            GlobalNotification.error(`${i18n.t('group_management_page_text_failed_get_group_list')}`);
            this.loadedTable();
        }
    }

    // 获取餐馆删除资源数据
    async getRestaurantDeletedList(extraParams?: Condition) {
        try {
            /**
             * 1.开启table loading
             * 2.无论成功与否关闭loading
             */
            this.loadTable();
            const params = {
                is_deleted: true,
                pagination_per_page: 999,
                pagination_page: 1,
                sort_key: 'deleted_date',
                sort_value: -1,
                ...extraParams
            }
            const result = await apiManage.get_restaurant_condition(params);
            // 请求成功
            if (!result.error) {
                // 解构数据
                const data = _.get(result, '[0]', {} as {
                    dbResults: Restaurant[], totalCount: Array<{
                        count: number;
                    }>
                });
                const { dbResults } = data;
                runInAction(() => {
                    this.tableLists.restaurant = dbResults || [];
                })
            } else {
                // 请求失败
                GlobalNotification.error(`${i18n.t('restaurant_page_request_text_failed_to_get_a_list_of_restaurants')}`);
            }
            this.loadedTable();
        } catch (e) {
            console.log(e);
            // 请求失败
            GlobalNotification.error(`${i18n.t('restaurant_page_request_text_failed_to_get_a_list_of_restaurants')}`);
            this.loadedTable();
        }

    }

    // 获取账号删除资源数据
    async getAccountDeletedList(extraParams?: Condition) {
        try {
            /**
             * 1.开启table loading
             * 2.无论成功与否关闭loading
             */
            this.loadTable();
            const params = {
                is_deleted: true,
                pagination_per_page: 999,
                pagination_page: 1,
                sort_key: 'deleted_date',
                sort_value: -1,
                ...extraParams
            }
            const result = await apiManage.get_staff_condition(params);
            // 请求成功
            if (!result.error) {
                // 解构数据
                const data = _.get(result, '[0]', {} as {
                    dbResults: Staff[], totalCount: Array<{
                        count: number;
                    }>
                });
                const { dbResults } = data;
                runInAction(() => {
                    this.tableLists.account = dbResults || [];
                    // this.dataTotal = totalCount[0]?.count || 0;
                })
            } else {
                // 请求失败
                GlobalNotification.error(`${i18n.t('ground_staff_component_message_failed_get_employee_list')}`);
            }
            this.loadedTable();
        } catch (e) {
            console.log(e);
            // 请求失败
            GlobalNotification.error(`${i18n.t('ground_staff_component_message_failed_get_employee_list')}`);
            this.loadedTable();
        }
    }

    // 获取经销商删除资源数据   
    async getResellerDeletedList(extraParams?: Condition) {
        try {
            /**
             * 1.开启table loading
             * 2.无论成功与否关闭loading
             */
            this.loadTable();
            const params = {
                is_deleted: true,
                pagination_per_page: 999,
                pagination_page: 1,
                sort_key: 'deleted_date',
                sort_value: -1,
                ...extraParams
            }
            const result = await apiManage.get_reseller_condition(params);
            // 请求成功
            if (!result.error) {
                // 解构数据
                const data = _.get(result, '[0]', {} as {
                    dbResults: Reseller[], totalCount: Array<{
                        count: number;
                    }>
                });
                const { dbResults } = data;
                runInAction(() => {
                    this.tableLists.reseller = dbResults || [];
                })
            }
            this.loadedTable();
        } catch (e) {
            console.log(e);
            this.loadedTable();
        }
    }

    /**
     * 设置选择列表数据展示的值
     * @param value @typedef SelectType
     */
    async setSelectValue(value: SelectType) {
        this.selectValue = value;
        // 切换下拉框时置空排序参数
        this.setExtraSortParams({
            sort_key: '',
            sort_value: '',
            sort_control: 0
        });
        await this.refreshData();
    }

    /**
     * 还原删除的数据
     * @param selected 
     */
    handleRestoreDialog(selected: Data[]) {
        let desc = '';
        if (this.selectValue === 'group') {
            // 集团
            desc = i18n.t('recycle_bin_page_text_restore_btn_desc_group');
        } else if (this.selectValue === 'reseller') {
            // 经销商
            desc = i18n.t('recycle_bin_page_text_restore_btn_desc_reseller')
        } else {
            // 其他
            desc = i18n.t('recycle_bin_page_text_restore_btn_desc');
        }
        this.updateConfirmDialogConfig({
            type: 'RESTORE',
            visible: true,
            desc,
            handleClick: async (isRestoreStaffRestaurant) => {
                // 请求还原
                await this.handleRestore(selected, isRestoreStaffRestaurant);
            }
        });
    }

    /**
     * 还原删除的数据
     * @param selected 
     * @param isRestoreStaffRestaurant true：还原集团下的餐馆和员工；反之不还原
     */
    async handleRestore(selected: Data[], isRestoreStaffRestaurant?: boolean) {
        const ids = selected.map((item) => item._id)
        const params = ids.map((item) => ({
            _id: item,
            //true：还原集团下的餐馆和员工；反之不还原
            is_restore_staff_restaurant: !!isRestoreStaffRestaurant
        }))
        let result;
        switch (this.selectValue) {
            case 'group':
                result = await apiManage.patch_restore_delete_group(params)
                break;
            case 'restaurant':
                result = await apiManage.patch_restore_delete_restaurant(ids)
                break;
            case 'account':
                result = await apiManage.patch_restore_delete_staff(ids)
                break;
            case 'reseller':
                result = await apiManage.patch_restore_delete_reseller(ids, !!isRestoreStaffRestaurant)
                break;
        }
        // 关闭弹窗
        this.updateConfirmDialogConfig({
            visible: false
        })
        if (result && !result?.error) {
            GlobalNotification.success(i18n.t('global_text_operate_success'));
            // 刷新数据
            await this.refreshData();
        } else {
            let errorMessage = ''
            const message: string = result?.result?.details ?? '';
            // 集团被删除
            if (message.includes('group is delete')) {
                errorMessage = i18n.t('recycle_bin_page_text_restore_error')
            } else if(message.includes('Reseller already removed')){
                errorMessage = i18n.t('recycle_bin_page_text_restore_error_reseller_deleted')
            }
            GlobalNotification.error(`${i18n.t('global_text_operate_failure')} ${errorMessage}`);
        }
    }

}

// 数据格式
type DeletedResourceData = {
    // 下拉框默认值
    selectValue: string;
}
/**
 * 表格排序的键值
 */
type sortKeyType = Pick<Group, 'nickname' | 'city' | 'deleted_date'>;
/**
 * 下拉框选择的值 集团 餐厅 账号
 */
export type SelectType = 'group' | 'restaurant' | 'account' | 'reseller';